import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { message, Spin } from "antd";
import { buildEmptyMaxMinPrice } from "../../../_events/max_min_prices/max_min_price.model";
import { createMaxMinPricesEvent } from "../../../_events/max_min_prices/create_max_min_prices.event";
import { Alert, AlertTitle, TextField } from "@mui/material";
import { findAllMaxMinPricesEvent } from "../../../_events/max_min_prices/find_max_min_prices.event";
import Table from "./table";
import UploadFile from "../../../containers/upload_file/upload_file";
import PrimaryProgress from "../../../containers/progress/primary_progress";

const MaxMinPrices = () => {

    const [data, setData] = useState([]);
    const [render, setRender] = useState('info');

    const findData = () => {
        findAllMaxMinPricesEvent()
        .then(data => {
            setData(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    React.useEffect(() => {
        findData();
    }, []);  

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                 <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width:'50%'}}>
                        <Typography variant="h6" component="h6">
                            Límites de precios
                        </Typography>
                    </div>                    
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'50%'}}>
                        {
                            render === 'info' ? 
                            <Button onClick={() => {setRender('form');}} variant="contained">Actualizar</Button>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                <div style={{overflowY: 'auto'}}>
                    {
                        render === 'info' ? <Table data={data} /> : <PocketBalanceForm />
                    }   
                </div>       
            </Grid>
        </Grid>
    );
}

const PocketBalanceForm = (props) => {

    const [dataUpload, setDataUpload] = useState([]);
    const [loadingData, setLoadingData] = useState(false);

    const buildExcelBytes = (e, onSuccess) => {
        let extension = '.';
        e.preventDefault()
        const reader = new FileReader()
        reader.onload = async (e) => { 
            let bytes_file = (e.target.result);
            onSuccess(bytes_file, extension);
        };
        if(e.target.files.length > 0){
            extension = e.target.files[0].name.split('.')[1];
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const uploadData = (bytes, extension, type) => {
        setLoadingData(true);
        //TODO FETCH TO UPLOAD
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <UploadFile
                        readFile={
                            (e) => buildExcelBytes(e, 
                                (bytes, ext) => uploadData(bytes, ext, 'pb')
                            )
                        }
                    />
                </Grid>    
                <Grid item xs={12} md={12}>
                    {
                        loadingData ? (
                            <PrimaryProgress />
                        ) : (
                            <Alert severity="info">
                                <AlertTitle>Datos actualizados:</AlertTitle>
                                <span>{dataUpload.length}</span>
                            </Alert>
                            
                        )
                    }
                </Grid>               
            </Grid>
        </div>
    );
}

const MaxMinPricesForm = (props) => {

    const [entity, setEntity] = useState(buildEmptyMaxMinPrice());
    const [loadingData, setLoadingData] = useState(false);

    const create = () => {
        setLoadingData(true);
        createMaxMinPricesEvent(entity)
        .then(data => {
            setLoadingData(false);
            setEntity(buildEmptyMaxMinPrice());
            document.getElementById('ref').value = '';
            document.getElementById('min_price').value = 0;
            document.getElementById('max_price').value = 0;
            props.loadData();
        })
        .catch(err => {
            message.error(err.message);
            setLoadingData(false);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={4}>
                    <TextField
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="ref" 
                        label="Referencia" 
                        variant="outlined"
                        size="small"
                        defaultValue={entity ? entity.ref : null}
                        onChange={(e) => {
                            let newData = {...entity};
                            newData.ref = e.target.value;
                            setEntity(newData);
                        }}
                    />         
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="min_price" 
                        label="Precio mínimo" 
                        variant="outlined"
                        size="small"
                        defaultValue={entity ? entity.min_price : null}
                        onChange={(e) => {
                            let newData = {...entity};
                            newData.min_price = e.target.value;
                            setEntity(newData);
                        }}
                    /> 
                </Grid>  
                <Grid item xs={12} md={4}>
                <TextField
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="max_price" 
                        label="Precio máximo" 
                        variant="outlined"
                        size="small"
                        defaultValue={entity ? entity.max_price : null}
                        onChange={(e) => {
                            let newData = {...entity};
                            newData.max_price = e.target.value;
                            setEntity(newData);
                        }}
                    /> 
                </Grid>   
                <Grid item xs={12} md={12}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        {
                            loadingData ? <Spin /> :
                            <Button variant="contained" size="small" onClick={() => create()}>Agregar</Button>
                        }
                    </div>
                </Grid>               
            </Grid>
        </div>
    );
}

export default MaxMinPrices;